export const API_CONFIG = {
  development: {
    baseUrl: '/api',
  },
  production: {
    baseUrl: 'https://profileupdates.api.taylorwessing.com',
  },
};
